<script setup>
import { computed } from "vue";
import Spinner from "@/components/Spinner/Spinner.vue";

const props = defineProps({
  size: {
    type: String,
    default: "medium",
    validator: (value) => ["extra-small", "small", "medium", "large"].includes(value)
  },
  pressed: {
    type: Boolean,
    default: false
  },
  active: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  }
});

const buttonClasses = computed(() => [
  "button-icon-neutral-secondary",
  `button-icon-neutral-secondary--${props.size}`,
  {
    "button-icon-neutral-secondary--pressed": props.pressed,
    "button-icon-neutral-secondary--active": props.active
  }
]);
</script>

<template>
  <button
    :disabled="props.disabled"
    :class="buttonClasses"
    :aria-pressed="props.pressed ? 'true' : 'false'"
    type="button"
  >
    <Spinner v-if="pressed" />
    <slot v-else />
  </button>
</template>

<style scoped lang="scss">

.button-icon-neutral-secondary {
  // Сброс дефолтных стилей.
  border: none;
  outline: none;
  background: none;
  margin: 0;
  padding: 0;
  font: inherit;

  // Стили кнопки.
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: center;
  background: var(--button-secondary-neutral-default);
  color: var(--icon-icon-primary);
  border-radius: 50%;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;

  cursor: pointer;
  user-select: none;

  // Состояния

  &:hover:not(:disabled):not(&--pressed):not(&--active) {
    color: var(--button-secondary-neutral-hover-icon);
    background: var(--button-secondary-neutral-hover);
  }

  &:focus-visible {
    outline: 2px solid var(--button-secondary-accent-focused);
    outline-offset: 2px;
  }

  &:disabled {
    pointer-events: none;
    color: var(--icon-icon-disabled);
    background: var(--button-secondary-neutral-disabled);
  }

  &--active {
    color: var(--button-secondary-neutral-hover-icon);
    background: var(--button-secondary-neutral-hover);
  }

  &--pressed {
    pointer-events: none;
    background: var(--button-secondary-accent-pressed);
    
    ::v-deep(.spinner) {
      border-color: var(--button-secondary-neutral-pressed-icon);
      border-bottom-color: transparent;
    }
  }

  // Размеры
  &--extra-small { height: 24px; width: 24px; }

  &--small { width: 30px; height: 30px; }

  &--medium { width: 36px; height: 36px; }

  &--large { width: 42px; height: 42px; }
}

</style>